import { prop } from "ramda";
import { createSelector } from "reselect";
import { ENTITLEMENT_LIST, LOADER_IDENTIFIER } from "./constants";

const userEntitlementState = (state: any) => state.userEntitlement;

export const selectUserEntitlementLoader: any = createSelector(
  userEntitlementState,
  prop(LOADER_IDENTIFIER)
);

export const selectUserEntitlementList: any = createSelector(
  userEntitlementState,
  prop(ENTITLEMENT_LIST)
);
